<div style="display: grid; max-width: 100ch; width: 50ch; vertical-align: middle">
  <form [formGroup]="loginForm" style="display: grid; width: 100%" (submit)="login($event)" autocomplete="on">
    <mat-form-field>
      <mat-label i18n>Username</mat-label>
      <input matInput formControlName="username" autocomplete="username" />
    </mat-form-field>
    <mat-form-field>
      <mat-label i18n>Password</mat-label>
      <input matInput formControlName="password" type="password" autocomplete="current-password" />
    </mat-form-field>

    <button mat-raised-button color="primary" type="submit" i18n>Log in</button>
  </form>
  <div style="display: grid; grid-template-columns: 1fr 1fr">
    <button mat-button routerLink="../register" i18n="Register user in portal">Register</button>
    <button mat-button routerLink="../reset-password-initiate" i18n>Reset password</button>
  </div>
</div>
